/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.followupEmailWorkflows.emailIsSelectedForForm.${key}`;
const EmailSelectedForFormAlert = ({
  editModule,
  editSmartRule,
  formFieldPath,
  inSameModule,
  scrollToFollowupEmail
}) => {
  let alertMessage;
  const scrollToEmail = (afterRemount = false) => {
    scrollToFollowupEmail(formFieldPath, afterRemount);
  };
  if (inSameModule && editSmartRule) {
    const smartRuleLink = /*#__PURE__*/_jsx(Link, {
      onClick: () => {
        scrollToEmail(true);
        editSmartRule();
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('inSameModule.smartRuleLink')
      })
    });
    alertMessage = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('inSameModule.smartRuleMessage'),
      options: {
        smartRuleLink
      }
    });
  } else if (inSameModule) {
    alertMessage = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('inSameModule.message'),
      options: {
        fieldLink: /*#__PURE__*/_jsx(Link, {
          onClick: () => scrollToEmail(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('inSameModule.fieldLink')
          })
        })
      }
    });
  } else {
    alertMessage = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('inOtherModule.message'),
      options: {
        formAutomation: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('inOtherModule.formAutomation')
          })
        }),
        otherModuleLink: editModule ? /*#__PURE__*/_jsx(Link, {
          onClick: () => {
            scrollToEmail(true);
            editModule();
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('inOtherModule.otherModuleLink')
          })
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('inOtherModule.otherModuleLink')
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    children: alertMessage
  });
};
export default EmailSelectedForFormAlert;